import dayjs from 'dayjs';

/**
 * Formats a given date (string or Date object) into "MMMM d, yyyy h:mm a" format.
 * Optionally, it can adjust the date based on a provided UTC offset.
 *
 * @param date - The input date (UTC).
 * @param timezoneLocale - A string like 'America/Los_Angeles'.
 * @example output: March 20, 2025 10:43 PM
 */
export const getFormattedDateInMMMMdyyyyWithTime = (
  dateInput: string | Date,
  timezoneLocale?: string,
): string => {
  let date = dayjs(dateInput);

  // If a timezone locale is provided, convert
  if (timezoneLocale) {
    date = date.tz(timezoneLocale);
  }

  return date.format('MMMM D, YYYY h:mm A');
};
